export const cancelButton = theme => ({
  color: theme.palette.secondary.medium,
  margin: theme.spacing('auto', -0.5, 'auto', 'auto'),
  padding: 0,
});

export const filterDrawer = theme => ({
  borderRadius: '4px 0 0 4px',
  boxShadow: theme.shadows[3],
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1, 0),
  width: 290,
  [theme.breakpoints.up('lg')]: {
    borderRadius: 0,
    padding: theme.spacing(3, 4),
  },
});

export const mobileDividerDown = theme => ({
  marginBottom: theme.spacing(3),
});

export const mobileHeader = theme => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(1, 2),
});

export const mobilePadding = theme => ({
  padding: theme.spacing(0, 3),
});

export const mobileTitle = {
  fontSize: 20,
};
